module.exports = __webpack_public_path__ + "static/media/mobileCommands.1953d701.svg";